import React from "react";

const StatusDropdown = ({ status, setStatus }) => {


	const handleChange = (event) => {
		setStatus(event.target.value); // Update state when the dropdown value changes
	};

	return (
		<div>
			{/* <label htmlFor="status-dropdown">Select Status</label> */}
			<select
				id="status-dropdown"
				value={status}
				onChange={handleChange}
				style={{
					padding: "8px",
					borderRadius: "10px",
				}}
			>
				<option value="" disabled>
					-- Choose an option --
				</option>
				<option value="HIRED">HIRED</option>
				<option value="RESIGNED">RESIGNED</option>
			</select>

		</div>
	);
};

export default StatusDropdown;
